document.addEventListener("DOMContentLoaded", function () {
  const script = document.getElementById("merchantWidgetScript");

  if (script) {
    script.addEventListener("load", function () {
      if (window.merchantwidget) {
        merchantwidget.start({
          merchant_id: 128457194,
          position: "LEFT_BOTTOM",
        });
      }
    });
  }
});
